// assets
import { IconUsers } from '@tabler/icons-react';

// constant
const icons = { IconUsers };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const users = {
  id: 'users',
  title: 'Users',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Users',
      type: 'item',
      url: '/users/default',
      icon: icons.IconUsers,
      breadcrumbs: false
    }
  ]
};

export default users;
